import doubleRoom1 from '../assets/double_gal3.jpg';
import doubleRoom2 from '../assets/ChatGPT_Image_1_mars_2026,_16_52_16 copy.png';
import doubleRoom3 from '../assets/ChatGPT_Image_1_mars_2026,_16_50_47 copy.png';
import doubleRoomBath from '../assets/ChatGPT_Image_1_mars_2026,_16_40_35 copy copy copy copy.png';
import tripleRoom1 from '../assets/triple_gal2.jpg';
import tripleRoom2 from '../assets/ChatGPT_Image_1_mars_2026,_16_44_14 copy.png';
import tripleRoom3 from '../assets/ChatGPT_Image_1_mars_2026,_17_17_15 copy copy copy.png';
import tripleBath from '../assets/ChatGPT_Image_1_mars_2026,_16_41_57 copy copy copy copy.png';
import quadRoom1 from '../assets/ChatGPT_Image_27_fevr._2026,_22_07_59 copy copy copy copy.png';
import quadRoom2 from '../assets/ChatGPT_Image_1_mars_2026,_17_17_15 copy copy copy copy copy copy.png';
import quadRoom3 from '../assets/ChatGPT_Image_1_mars_2026,_16_41_57 copy copy copy copy copy copy.png';
import quadBath from '../assets/ChatGPT_Image_1_mars_2026,_16_40_35 copy copy copy copy copy.png';
import familyRoom1 from '../assets/ChatGPT_Image_1_mars_2026,_17_17_15 copy copy copy copy copy copy copy.png';
import familyRoom2 from '../assets/ChatGPT_Image_1_mars_2026,_17_17_15 copy copy copy copy.png';
import familyRoom3 from '../assets/ChatGPT_Image_1_mars_2026,_17_20_47 copy.png';
import familyBath from '../assets/ChatGPT_Image_1_mars_2026,_16_41_57 copy copy copy copy copy.png';
import logo from '../../public/Sans_titre__Carte_de_visiyte_-removebg-preview.png';
import buildingExterior from '../assets/ChatGPT_Image_1_mars_2026,_19_31_41.png';

export const images = {
  common: {
    logo,
    hero: buildingExterior,
    kitchen: 'https://images.unsplash.com/photo-1556911220-bff31c812dba?auto=format&fit=crop&q=80',
    bathroom1: 'https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?auto=format&fit=crop&q=80',
    bathroom2: 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&q=80',
    hallway: 'https://images.unsplash.com/photo-1590381105924-c72589b9ef3f?auto=format&fit=crop&q=80'
  },
  rooms: {
    standard: {
      room1: 'https://images.unsplash.com/photo-1618773928121-c32242e63f39?auto=format&fit=crop&q=80',
      room2: 'https://images.unsplash.com/photo-1505693314120-0d443867891c?auto=format&fit=crop&q=80',
      room3: 'https://images.unsplash.com/photo-1582582621959-48d27397dc69?auto=format&fit=crop&q=80',
      doubleGallery: [doubleRoom1, doubleRoom2, doubleRoom3, doubleRoomBath],
      tripleGallery: [tripleRoom1, tripleRoom2, tripleRoom3, tripleBath],
      quadGallery: [quadRoom1, quadRoom2, quadRoom3, quadBath],
      familyGallery: [familyRoom2, familyRoom1, familyRoom3, familyBath]
    },
    luxury: {
      room1: 'https://images.unsplash.com/photo-1578683010236-d716f9a3f461?auto=format&fit=crop&q=80',
      room2: 'https://images.unsplash.com/photo-1631049307264-da0ec9d70304?auto=format&fit=crop&q=80',
      room3: 'https://images.unsplash.com/photo-1604709177225-055f99402ea3?auto=format&fit=crop&q=80'
    }
  }
};